jQuery(document).ready(function ($) {
    const closeAllPopups = () => {
        $('body').css({ overflow: 'unset' });
        $('.popup').removeClass('active');
    };

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        const $input = $(`[name="_wpcf7"][value="${event.detail.contactFormId}"]`).closest('form').find('[name="success-popup"]');
        if($input.length && $($input.val()).length) {
            closeAllPopups();
            $('body').css({ overflow: 'hidden' });
            $($input.val()).addClass('active');
        }
    }, false );
});
